import React, { Component } from "react";
import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";
import { connect } from "react-redux";

import "./LoginCard.component.scss";
import LoginForm from "./LoginForm/LoginForm.component";
import { ActionCreator } from "../../../../../actions/actions";
import { AuthActionCreators } from "../../../actions/actionCreators";

export interface LoginCardProps {
    login: ActionCreator;
    suggestion: any;
    onChangePage: any;
}

class LoginCard extends Component<LoginCardProps, {}> {
    render() {
        return (
            <div id="LoginCard">
                <div>
                    <div className="title-1">Welcome,</div>
                    <div className="title-2">Sign in to your account</div>

                    <LoginForm
                        onSubmit={this.props.login}
                        onChangePage={this.props.onChangePage}
                    />
                    {this.props.suggestion}
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = {
    login: AuthActionCreators.login
};

export default connect(
    null,
    mapDispatchToProps
)(LoginCard);
